import { type ReactNode, type CSSProperties } from 'react'

type Surface = 'base' | 'raised' | 'glass'

interface Props {
  children?: ReactNode
  surface?: Surface
  padded?: boolean
  flush?: boolean
  clickable?: boolean
  className?: string
  style?: CSSProperties
  onClick?: () => void
}

const SURFACE_CLASS: Record<Surface, string> = {
  base: '',
  raised: 'cf-surface-raised',
  glass: 'cf-glass',
}

export function Card({
  children,
  surface = 'base',
  padded = true,
  flush = false,
  clickable = false,
  className = '',
  style,
  onClick,
}: Props) {
  const cls = [
    'cf-card',
    SURFACE_CLASS[surface],
    flush ? 'cf-card--flush' : padded ? 'cf-card--padded' : '',
    clickable ? 'cf-card--clickable' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ')

  if (clickable) {
    return (
      <button type='button' className={cls} style={style} onClick={onClick}>
        {children}
      </button>
    )
  }

  return (
    <div className={cls} style={style}>
      {children}
    </div>
  )
}
